export default __webpack_public_path__ + "static/cp-app-screens-0979c14681f6ce42a4c1c35d8053e2e0.jpg";